module.exports = __webpack_public_path__ + "108f7e726a9a85baa2a93268a55407e4.png";